import Product, { ProductLite } from '@src/quince-site-common/src/domains/Product'
import Bundle from '@src/quince-site-common/src/domains/Product/BundleProduct'
import { isProductCaviar } from '@src/quince-site-common/src/helpers/productHelper'
import { TFunction } from 'next-i18next'

export const getDetailsAndCareConfig = (product: Product | ProductLite | Bundle, t: TFunction) => {
  // @i18n-ignore
  let contentContainerDisplayName = 'Product Details, Size & Fit, Care'

  const tabTitles = {
    productDetails: t('details_v1'),
    productSizeAndFit: t('size_fit'),
    productCare: t('care'),
    productBenefits: t('benefits'),
    productIngredients: t('ingredients'),
    productNotes: t('notes'),
    productInstallation: t('installation'),
    productSpecs: t('specs'),
    productDimensions: t('dimensions'),
  }

  const isProductCaviarFlag = isProductCaviar(product)
  if (isProductCaviarFlag) {
    // @i18n-ignore
    contentContainerDisplayName = 'Product Details, Shelf Life, Shipping'
    tabTitles.productSizeAndFit = t('shelf_life')
    tabTitles.productCare = t('shipping_v1')
  }

  return {
    contentContainerDisplayName,
    tabTitles,
  }
}
